import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { getIsLoggedIn } from '../state/authentication.selector';

@Injectable({
   providedIn: 'root',
})
export class LoginGuard  {
   constructor(private store: Store) {}

   /**
    * Users shouldn't be able to navigate to /login if you're already logged in.
    * Returning false will redirect the user to the default route on page load,
    * or leave them where they are if they somehow click a 'login' link
    */
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      return this.isNotLoggedIn(route);
   }

   private isNotLoggedIn(route: ActivatedRouteSnapshot): Observable<boolean> {
      return this.store.pipe(
         select(getIsLoggedIn),
         first(),
         map((isLoggedIn) => {
            return !isLoggedIn;
         })
      );
   }
}
